import * as React from 'react';
import { useMemo } from 'react';
import { ProgressProps } from './IProgress';
import "./Progress.scss";

const Progress = (props: ProgressProps) => {
  const defaultHeight = 18;
  const progressNumber = useMemo(() => {
    if (!props.label)
      return (<div className="num">
        {props.progress + " / " + props.limit}
      </div>);
    
    const params: {[key: string]: number} = {
      progress: props.progress,
      red: props.limit - props.progress,
      limit: props.limit
    };
    return <div className="num">{
      props.label.replace(/({.*?})/g, (w, $1) => {
        const key = $1.match(/{(.+?)}/)[1];
        const p = params[key];
        if (null === p || undefined === p)
          throw new Error(`params is null. (${key})\n${JSON.stringify(params, null, 2)}`);
        return params[key] >= 0 ? (params[key]?.toString() || '') : "0";
      })
    }</div>;
  }, [props.progress, props.limit]);

  const height = useMemo(() => {
    if (null === props.height || undefined === props.height || Number.isNaN(props.height)) return defaultHeight;
    return Math.max(props.height, defaultHeight);
  }, []);

  const width = useMemo(() => {
    const ret = !props.doing ?
      0 :
      (null != props.limit && null != props.progress ?
        `calc(100% / ${props.limit + 1} * ${props.progress + 1})` :
        0
      );
    if (Number.isNaN(ret)) return 0;
    return ret;
  }, [props.doing, props.limit, props.progress]);
  
  return (
    <div
      className={"progress-bar" + (props.doing ? " doing" : "")}
      style={{
        height,
        color: props?.colors?.font || "initial",
        backgroundColor: props?.colors?.secondary || "#ffffff",
        ...(props.style || {})
      }}>
      {props.bar ?
        <div className="bar" style={{
          height: typeof props.bar.height === "number" ? props.bar.height : height,
          backgroundColor: props.bar?.color || props?.colors?.primary || "inherit",
          width
        }}>
        </div> : <></>
      }
      {progressNumber}
    </div>
  )
}

export default Progress;